// Shared UI primitive (reused across all dashboard pages) — MIS-809.
//
// A plain styled <label>. `htmlFor` ties it to an input by id for accessibility.

import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
  // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor is supplied by callers.
  <label
    ref={ref}
    className={cn('block text-sm font-medium text-[var(--muted)]', className)}
    {...props}
  />
));
Label.displayName = 'Label';
